import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';

const API_URL = window.location.protocol + '//api.' + window.location.hostname + (window.location.port === '8000' ? ':8001' : '') + '/api';
// const API_URL = 'http://api.localhost:8000/api';

export const getDeliveryForms = async (data) => {
  try {
    const response = await axios.post( API_URL + '/orders/deliveryForms', data)
    // console.log(response);
    return response.data.data;
  } catch (error) {
    console.error({error});
    throw error;
  }

}

export const getPromoProducts = function () {
  return axios.get( API_URL + '/products/getPromoProducts' )
    .then(function (response) {
      return response.data.data;
    })
}

export const getHomepagePromoProducts = function () {
  return axios.get( API_URL + '/products/getHomepagePromoProducts' )
    .then(function (response) {
      return response.data.data;
    })
}

export const getManufacturers = function () {
  return axios.get( API_URL + '/users/getManufacturers')
    .then(function (response) {
      return response.data.data;
    })
}

export const getPrimaryCategories = function () {
  return axios.get( API_URL + '/categories/getPrimaryCategories')
    .then(function (response) {
      return response.data.data;
    })
}

export const getBranches = function () {
  return axios.get( API_URL + '/branches/getBranches')
    .then(function (response) {
      return response.data.data;
    })
}

export const getAllProducts = function () {
  return axios.get( API_URL + '/products/getAllProducts' )
    .then(function (response) {
      return response.data.data;
    })
}

export const getProductsByCategorySlug = function (slug, setProductsByCat) {
  return axios.get( API_URL + `/products/getProductsByCategorySlug/${slug}` )
    .then(function (response) {
      setProductsByCat(response.data.data);
      return response.data.data;
    })
}

export const searchProducts = function (searchInput, setIsLoading, setProductsSearch) {
  return axios.get( API_URL + `/products/searchProduct/${searchInput}` )
    .then(function (response) {
      setIsLoading(false);
      setProductsSearch(response.data.data);
      return response.data.data;
    })
}

export const getProductBySlug = function (slug, setProductBySlug) {
  return axios.get( API_URL + `/products/getProductBySlug/${slug}` )
    .then(function (response) {
      if (setProductBySlug) {
        setProductBySlug(response.data.data);
      }
      return response.data.data;
    })
}

export const getProductLastPrice = function (slug) {
  return axios.get( API_URL + `/products/getProductLastPrice/${slug}`)
    .then(function (response) {
      return response.data.data;
    })
}

export const getProductPriceHistory = function (slug) {
  return axios.get( API_URL + `/products/getProductPriceHistory/${slug}`)
    .then(function (response) {
      return response.data.data;
    })
}

export const getProductImages = function (product_id, setImg) {
  return axios.get( API_URL + `/products/getProductImages/${product_id}` )
    .then(function (response) {
      setImg(response.data.data);
      return response.data.data;
    })
}

export const getAllPosts = function () {
  return axios.get( API_URL + '/posts/getAllPosts')
    .then(function (response) {
      return response.data.data.sort((a, b) => new Date(b.post_updated_at).getTime() - new Date(a.post_updated_at).getTime());
    })
}

export const getAllCategories = function () {
  return axios.get( API_URL + '/posts/getAllCategories')
    .then(function (response) {
      return response.data.data;
    })
}

export const getPostsByCategorySlug = function (slug) {
  return axios.get( API_URL + `/posts/getPostsByCategorySlug/${slug}`)
    .then(function (response) {
      return response.data.data.sort((a, b) => new Date(b.post_updated_at).getTime() - new Date(a.post_updated_at).getTime());
    })
}

export const getPostBySlug = function (slug) {
  return axios.get( API_URL + `/posts/getPostBySlug/${slug}`)
    .then(function (response) {
      return response.data.data;
    })
}

export const getOnProductDeliveryCost = function (branch_id, address_post) {
  return axios.get( API_URL + `/orders/getOnProductDeliveryCost/${branch_id}/${address_post}`)
    .then(function (response) {
      return response.data.data;
    })
}

export const getDeliveryCost = function (form, setDeliveryCost, setDeliveryCostErr) {
  return axios.post( API_URL + '/orders/getDeliveryCost', form)
    .then(function (response) {
      setDeliveryCost(response.data.data);
      return response.data.data;
    })
    .catch(function (error) {
      setDeliveryCostErr(true);
    })
}

export const checkIfEmailExist = function (email, setCheckEmail) {
  return axios.post( API_URL + '/users/checkIfEmailExist', email)
    .then(function (response) {
      setCheckEmail(true);
    })
    .catch(function (error) {
      setCheckEmail(false);
    })
}

export const checkIfPhoneExist = function (phone, setCheckPhone) {
  return axios.post( API_URL + '/users/checkIfPhoneExist', phone)
    .then(function (response) {
      setCheckPhone(true);
    })
    .catch(function (error) {
      setCheckPhone(false);
    })
}

export const addUserAddress = function (token, form, setOpen, setReload) {
  return axios.post( API_URL + '/users/addUserAddress', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOpen(false);
    setReload(true);
  })
}

export const updateUserAddress = function (token, form, setOpen, setReload) {
  return axios.post( API_URL + '/users/updateUserAddress', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOpen(false);
    setReload(true);
  })
}

export const getUserAddresses = function (token, setReload) {
  return axios.post( API_URL + '/users/getUserAddresses', {}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    if (setReload) {
      setReload(false);
    }
    return response.data.data;
  })
}

export const setUserAddressAsDefault = function (token, form, setReload) {
  return axios.post( API_URL + '/users/setUserAddressAsDefault', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setReload(true);
  })
}

export const deleteUserAddress = function (token, address_id, setReload) {
  return axios.get( API_URL + `/users/deleteUserAddress/${address_id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setReload(true);
  })
}

export const viewProfile = function (token, setUserSession) {
  return axios.get( API_URL + '/users/view-profile', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setUserSession(token, response.data.data);
    return response.data.data;
  })
}

export const updateProfile = function (token, form, setUserSession, setReload) {
  return axios.post( API_URL + '/users/update', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setUserSession(token, form);
    setReload(true);
  })
}

export const getPageBySlug = function (slug) {
  return axios.get( API_URL + `/pages/getPageBySlug/${slug}`)
    .then(function (response) {
      return response.data.data;
    })
}

export const newOrder = function (form, token, setIsSendCart, setDisabledBtn, setSendOrder, setOrder, sendClearCart) {
  return axios.post( API_URL + '/orders/newOrder', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOrder(response.data);
    setIsSendCart(true);
    setDisabledBtn(false);
    setSendOrder(false);
    if (sendClearCart) {
      sendClearCart();
    }
  })
}

export const newPPOrder = function (form, setSendOrder, setOrder) {
  return axios.post( API_URL + '/partnerProgram/newPPOrder', form)
  .then(function (response) {
    setSendOrder(false);
    setOrder(response.data.data)
  })
}

export const registerClient = function (form, setSuccess, setSendRegister) {
  return axios.post( API_URL + `/users/registerClient`, form)
    .then(function (response) {
      setSuccess(true);
      setSendRegister(false);
    })
}

export const registerContractor = function (form, setSuccess, setSendRegister) {
  return axios.post( API_URL + `/users/registerContractor`, form)
    .then(function (response) {
      setSuccess(true);
      setSendRegister(false);
    })
}

export const confirmToken = function (token, setConfirmError) {
  return axios.get( API_URL + `/users/confirmToken/${token}`)
    .then(function (response) {
      window.location = '/';
    }).catch(error => {
      setConfirmError(true);
    });
}

export const passwordReset = function (form, setSuccess, setPasswdReset) {
  return axios.post( API_URL + `/users/passwordReset`, form)
    .then(function (response) {
      setSuccess(true);
      setPasswdReset(false);
    })
}

export const userLogin = function (email, password, setUserSession, setError, location, setLoggedIn, setUserModal) {
  return axios.post( API_URL + '/users/login', {
    email: email,
    password: password
  })
  .then(function (response) {
    if (response.data.token && response.data.data) {
      setUserSession(response.data.token, response.data.data);
      window.location = `${(location.state && location.state.from) ? location.state.from : location.pathname ? location.pathname : '/'}`;
      toast.success("Zalogowano pomyślnie.");
    }
    if (setUserModal) {
      setUserModal(false);
      window.location = `${(location.state && location.state.from) ? location.state.from : location.pathname ? location.pathname : '/'}`;
    }
    if((location.state && (location.state.productPricingQty || location.state.productPricing || location.state.from)) && setLoggedIn) {
      setLoggedIn(true);
    }
  })
  .catch(function (error) {
    const { status } = error.response;
    const { email, password} = error.response.data.message;

    if (status === 500 && email && password) {
      setError("Aby się zalogować proszę podać swój adres e-mail oraz hasło.");
    } else if (status === 500 && password) {
      setError("Aby się zalogować proszę podać swoje hasło.");
    } else if (status === 500 && email) {
      setError("Aby się zalogować proszę podać swój adres e-mail.");
    } else if (status === 422 && error.response.data.message === "Nieprawidłowa nazwa użytkownika lub hasło") {
      setError("Nieprawidłowa nazwa użytkownika lub hasło.");
    } else if (status === 422 && error.response.data.message === "Użytkownik o danym adresie nie istnieje") {
      setError("Dany użytkownik nie istnieje lub rejestracja nie została potwierdzona.");
    } else {
      setError("Coś poszło nie tak. Spróbuj ponownie później.");
    }
    toast.error("Wystąpił błąd, spróbuj ponownie.");
  })
}

export const loginFB = function (data, setUserSession, location, setLoggedIn, setUserModal) {
  return axios.post( API_URL + '/users/loginFB', data)
  .then(function (response) {
    setUserSession(response.data.token, response.data.data);
    if (setUserModal) {
      setUserModal(false);
    }
    if((location.state && (location.state.productPricingQty || location.state.productPricing)) && setLoggedIn) {
      setLoggedIn(true);
    }
  })
}

export const getOrders = function (token) {
  return axios.get( API_URL + `/orders/index`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    return response.data.data.sort((a, b) => b.order_nr - a.order_nr);
  })
}

export const viewOrder = function (token, order_id, setOrder) {
  return axios.get( API_URL + `/orders/viewOrder/${order_id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOrder(response.data.data);
    return response.data.data;
  })
}

export const setOrderDelivered = function (token, order_id, setIsDelivered) {
  return axios.post( API_URL + '/orders/setOrderDelivered', {order_id: order_id}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setIsDelivered(true);
  })
}

export const providerCancelOrder = function (token, order_id, setIsCancelOrderBuy) {
  return axios.post( API_URL + '/orders/providerCancelOrder', {order_id: order_id}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setIsCancelOrderBuy(true);
  })
}

export const clientCancelOrder = function (token, order_id, setIsCancelOrderBuy) {
  return axios.post( API_URL + '/orders/clientCancelOrder', {order_id: order_id}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setIsCancelOrderBuy(true);
  })
}

export const pricingOrder = function (token, form, setIsSendPricing) {
  return axios.post( API_URL + '/orders/pricingOrder', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setIsSendPricing(true);
  })
}

export const acceptPricing = function (token, form, setPaymentToken, setLoading, setIsAcceptPricing) {
  return axios.post( API_URL + '/orders/acceptPricing', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setLoading(false);
    setIsAcceptPricing(true);
    setPaymentToken(response.data.data.token);
  })
}

export const setState = function (token, form) {
  return axios.post( API_URL + '/orders/setState', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    
  })
}

export const timeoutPricing = function (token, value) {
  return axios.post( API_URL + '/orders/timeoutPricing', {order_id: value}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    
  })
}

export const getCars = function (token, setReload) {
  return axios.get( API_URL + '/cars/index', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    if (setReload) {
      setReload(false);
    }
    return response.data.data;
  })
}

export const deleteCar = function (token, branch_car_id, setReload) {
  return axios.get( API_URL + `/cars/deleteCar/${branch_car_id}`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setReload(true);
  })
}

export const addCar = function (token, form, setOpen, setReload) {
  return axios.post( API_URL + '/cars/addCar', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOpen(false);
    setReload(true);
  })
}

export const updateCar = function (token, form, setOpen, setReload) {
  return axios.post( API_URL + '/cars/updateCar', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setOpen(false);
    setReload(true);
  })
}

export const branchProductsList = function (token, setReload) {
  return axios.get( API_URL + '/branches/getBranchProductsList', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) { 
    setReload(false);
    return response.data.data;
  })
}

// export const branchProductsListPage = function (token, pageNumber, toTop) {
//   return axios.get( API_URL + `/branches/getBranchProductsList?page=${pageNumber}`, {
//     headers: {
//       'Authorization': `Bearer ${token}`
//     }
//   })
//   .then(function (response) {
//     setTimeout(() => {
//       toTop();
//     }, 100);
//     return response.data.data;
//   })
// }

export const addBranchProduct = function (token, form, setReload) {
  return axios.post( API_URL + '/branches/addBranchProduct', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setReload(true);
  })
}

export const deleteBranchProduct = function (token, form, setReload) {
  return axios.post( API_URL + '/branches/deleteBranchProduct', form, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setReload(true);
  })
}

export const retryPaymentTransaction = function (token, order_id, setPaymentToken, setLoading) {
  return axios.post( API_URL + '/orders/retryPaymentTransaction', {order_id: order_id}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setLoading(false);
    setPaymentToken(response.data.data);
  })
}

export const getUserPayments = function (token, user_id) {
  return axios.post( API_URL + '/payments/getUserPayments', {user_id: user_id}, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    return response.data.data;
  })
}

export const getPartnerProgramProducts = function (token, setData) {
  return axios.get( API_URL + '/partnerProgram/getPartnerProgramProducts', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    setData(response.data.data);
    return response.data.data;
  })
}

export const getPartnerProgramCategories = function (token) {
  return axios.post( API_URL + '/partnerProgram/getPartnerProgramCategories', {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  })
  .then(function (response) {
    return response.data.data;
  })
}

export const sendContactMessage = function (form, setDisabledBtn, setSendOrder, setForm) {
  return axios.post( API_URL + `/pages/sendContactMessage`, form)
  .then(function (response) {
    // return response.data.data;
    setSendOrder(false);
    setDisabledBtn(false);
    setForm({
      name: "",
      email: "",
      phone: "",
      content: ""
    })
  })
}

export const getFavoriteProducts = function (user_id) {
  return axios.get( API_URL + `/products/getFavoriteProducts/${user_id}`)
  .then(function (response) {
    return response.data.data;
  })
}

export const addFavoriteProduct = function (data) {
  return axios.post( API_URL + `/products/addFavoriteProduct`, data)
  .then(function (response) {
    return response.data.data;
  })
}

export const deleteFavoriteProduct = function (id) {
  return axios.post( API_URL + `/products/deleteFavoriteProduct`, id)
  .then(function (response) {
    return response.data.data;
  })
}

export const confirmSMSToken = function (code) {
  return axios.post( API_URL + `/users/confirmSMSToken`, {sms_token: code})
}

export const confirmSMSPasswordReset = function (code) {
  return axios.post( API_URL + `/users/confirmSMSPasswordReset`, {sms_token: code})
}